import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import { transformPrintOnDemandIds } from "@design-lab/shared/lib/misc";
import { useIsSample } from "@design-lab/shared/lib/config";

export function usePrintOnDemandProduct(productId?: string, designLab: boolean = true) {
  const isSample = useIsSample();

  return useQuery({
    enabled: !!productId,
    ...prepareRequest(productId, isSample, designLab)
  });
}

export function useFetchPrintOnDemandProduct(designLab: boolean = true) {
  const queryClient = useQueryClient();
  const isSample = useIsSample();

  return useCallback(
    (productId: string) => queryClient.fetchQuery(prepareRequest(productId, isSample, designLab)),
    [queryClient, isSample, designLab]
  );
}

function prepareRequest(productId?: string, isSample?: boolean, designLab: boolean = true) {
  return {
    queryKey: [
      "product",
      productId,
      isSample ? "sample" : "regular",
      ...(designLab ? ["design_lab"] : [])
    ],
    queryFn: () => {
      if (!productId) return undefined;

      return api.printOnDemand
        .getProduct(
          { catalog_number: productId },
          { ...(designLab ? { design_lab: "true" } : {}), ...(isSample ? { sample: "true" } : {}) }
        )
        .then(objNamesToCamelCase)
        .then(transformPrintOnDemandIds);
    }
  };
}
